const NaoEncontrada = () => {
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
      padding: "2rem",
      textAlign: "center",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }}>
      <div style={{
        background: "white",
        borderRadius: "16px",
        padding: "3rem 2rem",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
        maxWidth: "600px",
        width: "100%"
      }}>
        <div style={{
          fontSize: "6rem",
          fontWeight: "bold",
          color: "#4a6bdf",
          marginBottom: "1rem",
          lineHeight: 1
        }}>
          404
        </div>
        
        <h1 style={{
          fontSize: "2rem",
          color: "#2d3748",
          marginBottom: "1rem"
        }}>
          Oops! Página não encontrada
        </h1>
        
        <p style={{
          color: "#718096",
          marginBottom: "2rem",
          fontSize: "1.1rem",
          lineHeight: 1.6
        }}>
          Parece que a página que você está tentando acessar não existe ou foi movida.
          Verifique o endereço ou volte para a página inicial.
        </p>
        
        <div style={{
          display: "flex",
          gap: "1rem",
          justifyContent: "center",
          flexWrap: "wrap"
        }}>
          
          
          <button 
            onClick={() => window.history.back()} 
            style={{
              background: "white",
              color: "#4a6bdf",
              padding: "0.8rem 2rem",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "600",
              transition: "all 0.3s ease",
              border: "2px solid #4a6bdf",
              fontSize: "1rem",
              cursor: "pointer"
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#4a6bdf";
              e.target.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "white";
              e.target.style.color = "#4a6bdf";
            }}
          >
            Voltar à página anterior
          </button>
        </div>
      </div>
      
      <div style={{
        marginTop: "2rem",
        color: "#718096",
        fontSize: "0.9rem"
      }}>
        <p>Se você acredita que isso é um erro, entre em contato com o suporte.</p>
      </div>
    </div>
  );
};

export default NaoEncontrada;